<template>
  <div>
    <div class="d-flex flex-wrap">
      <div class="card maadi-dark-card flex-fill d-flex m-1 p-1 align-items-center justify-content-center flex-wrap" v-for="invalidMemberQuality in dataQualityMetrics" :key="invalidMemberQuality.selector" v-on:click="setViolatingDataset(invalidMemberQuality)" style="cursor: pointer">
        <span style="font-size: 1em; text-transform: uppercase"> {{ invalidMemberQuality.title }} </span>
        <binary-pie-chart  v-bind:data="{selector: invalidMemberQuality.selector, dataSet: [invalidMemberQuality.dataset.length, members.length - invalidMemberQuality.dataset.length], colors: ['#C1272D', '#30455F']}"></binary-pie-chart>
        <div class="d-flex align-items-center flex-fill">
          {{ invalidMemberQuality.dataset.length }} / {{ members.length }}
        </div>
        <div v-if="invalidMemberQuality.explanation !== null" class="d-flex align-items-center flex-fill" style="font-size: 0.7em;">
          {{ invalidMemberQuality.explanation }}
        </div>
      </div>
    </div>
    <span id="violating-org"></span>
    <div class="card maadi-dark-card m-1" v-if="selectedViolatingDataset !== null" >
      <div class="card-body">
        <div class="text-center mb-3" style="text-transform: uppercase; font-size: 1.5em;">
          {{ selectedViolatingDataset.title }}
        </div>
        <div style="max-height: 250px; overflow-y: auto">
          <div v-for="organization in selectedViolatingDataset.dataset" :key="organization.account_id" class="d-flex m-1 p-2" style="border: 1px solid #3E597A">
            <single-member-validity-record v-bind:organization="organization"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BinaryPieChart from '../../tools/charts/BinaryPieChart'
import MembershipDashboardMixin from '../MembershipDashboardMixin'
import SingleMemberValidityRecord from './SingleMemberValidityRecord'

export default {
  name: '',
  mixins: [MembershipDashboardMixin],
  components: {BinaryPieChart, SingleMemberValidityRecord},
  data: function () {
    return {
      selectedViolatingDataset: null
    }
  },
  methods: {
    setViolatingDataset (violatingDataset) {
      this.selectedViolatingDataset = violatingDataset
      document.getElementById('violating-org').scrollIntoView()
    }
  },
  computed: {
    dataQualityMetrics: function () {
      return [
        {
          dataset: this.membersWithNoManager,
          selector: 'no-member-manager',
          title: 'members with no member manager',
          explanation: null
        },
        {
          dataset: this.membersWithNoPrimaryContact,
          selector: 'no-primary-contacts',
          title: 'members with no primary contacts',
          explanation: null
        },
        {
          dataset: this.membersNotCategorized,
          selector: 'have-no-listed-category',
          title: 'members without a category in Neon',
          explanation: 'No organization category is selected in Neon.'
        },
        {
          dataset: this.membersNotConnectedToQuickbooks,
          selector: 'not-connected-to-quickbooks',
          title: 'Members not connected to QuickBooks.',
          explanation: null
        },
        {
          dataset: this.membersNotConnectedToWordPress,
          selector: 'not-connected-to-worpress',
          title: 'Members not connected to WordPress.',
          explanation: null
        },
        {
          dataset: this.membersWithNoLogo,
          selector: 'no-logo',
          title: 'members with no logo.',
          explanation: null
        },
        {
          dataset: this.membersWithRectangularLogo,
          selector: 'square-logo',
          title: 'members with rectangular logo.',
          explanation: 'Member logos should be square to appear best on the member directory.'
        },
        {
          dataset: this.membersWithNoWebsite,
          selector: 'no-website',
          title: 'members with no website.',
          explanation: null
        },
        {
          dataset: this.membersWithInvalidWebsite,
          selector: 'invalid-website',
          title: 'members with an invalid website.',
          explanation: 'Member websites must begin with an \'http\' or \'https\''
        }, {
          dataset: this.membersWithNoLinkedIn,
          selector: 'no-linked-in',
          title: 'Members with no LinkedIn account.',
          explanation: null
        },
        {
          dataset: this.membersWithInvalidLinkedIn,
          selector: 'invalid-linked-in',
          title: 'Members with an invalid LinkedIn URL.',
          explanation: 'Member LinkedIn profiles must begin with an \'http\' or \'https\''
        },
        {
          dataset: this.membersWithNoTwitter,
          selector: 'no-twitter',
          title: 'Members with no Twitter account.',
          explanation: null
        },
        {
          dataset: this.membersWithInvalidTwitter,
          selector: 'invalid-twitter',
          title: 'Members with an invalid Twitter URL.',
          explanation: 'Member Twitter accounts should only be the screen name, not prefaced by \'@\''
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/membership/dataValidity/MembershipDataValidityDashboard.vue